import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useIntl } from 'react-intl';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#384B63',
        color: theme.palette.common.white,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    commentDiv: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

export default function DenseTable({
    firstApprover,
    firstApproverComment,
    secApprover,
    secApproverComment,
    HRComment
}) {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>{intl.formatMessage({ id: 'myleave.approver' })}</StyledTableCell>
                        <StyledTableCell>{intl.formatMessage({ id: 'comment' })}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {firstApprover ?
                        <TableRow>
                            <StyledTableCell component="th" scope="row">
                                {firstApprover}
                            </StyledTableCell>
                            <StyledTableCell>
                                {firstApproverComment &&
                                    <div className={classes.commentDiv}>
                                        {firstApproverComment.split("\n").map((comment, i) => (
                                            <p key={i}>{comment}</p>
                                        ))}
                                    </div>
                                }
                            </StyledTableCell>
                        </TableRow>
                        : null
                    }
                    {secApprover ?
                        <TableRow>
                            <StyledTableCell component="th" scope="row">
                                {secApprover}
                            </StyledTableCell>
                            <StyledTableCell>
                                {secApproverComment &&
                                    <div className={classes.commentDiv}>
                                        {secApproverComment.split("\n").map((comment, i) => (
                                            <p key={i}>{comment}</p>
                                        ))}
                                    </div>
                                }
                            </StyledTableCell>
                        </TableRow>
                        : null
                    }
                    <TableRow>
                        <StyledTableCell component="th" scope="row">
                            HR
                        </StyledTableCell>
                        <StyledTableCell>
                            {HRComment &&
                                <div className={classes.commentDiv}>
                                    {HRComment.split("\n").map((comment, i) => (
                                        <div key={i}>{comment}</div>
                                    ))}
                                </div>
                            }
                        </StyledTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}